import { __experimentalDivider as Divider } from '@wordpress/components';
import {
  LinkUrl,
  MediaFile,
  VideoPopup,
  FileDownload,
  EmbedCode,
} from './_partials';
import { preventPostSaveWithErrors } from '@helpers/input-validations';

const {
  i18n: { __ },
  components: { Panel, PanelBody, SelectControl },
  element: { useEffect, useState },
} = wp;

const LinkControls = (props) => {
  const {
    attributes,
    setAttributes,
    linkOptions = ['url', 'media', 'video', 'embed-code', 'download'],
  } = props;
  const { linkBehavior, link, media, downloadFile, embedCode } = attributes;
  const linkOptionsArray = [
    { label: 'Internal/External', value: 'url' },
    { label: 'Image Popup', value: 'media' },
    { label: 'Video Popup', value: 'video' },
    { label: 'Embed code/ Custom HTML Popup', value: 'embed-code' },
    { label: 'File Download', value: 'download' },
  ];
  const allowedLinkOptions = linkOptionsArray.filter((e) => {
    return linkOptions.includes(e.value);
  });

  const [errors, setErrors] = useState({});
  const [showToast, setShowToast] = useState(false);

  useEffect(() => {
    preventPostSaveWithErrors('validate-inputs', errors);
  }, [errors]);

  return (
    <Panel>
      <PanelBody title={__('Link', 'b3rg')} initialOpen={true}>
        <SelectControl
          label={__('Link Behavior', 'b3rg')}
          value={linkBehavior}
          options={allowedLinkOptions}
          onChange={(behavior) => {
            setAttributes({ linkBehavior: behavior });
          }}
        />
        <Divider />
        {linkBehavior === 'url' && <LinkUrl {...{ link, setAttributes }} />}
        {linkBehavior === 'media' && (
          <MediaFile {...{ media, setAttributes }} />
        )}
        {linkBehavior === 'video' && (
          <VideoPopup {...{ attributes, setAttributes }} />
        )}
        {linkBehavior === 'download' && (
          <FileDownload {...{ downloadFile, setAttributes }} />
        )}
        {linkBehavior === 'embed-code' && (
          <EmbedCode
            {...{
              embedCode,
              setAttributes,
              errors,
              setErrors,
              showToast,
              setShowToast,
            }}
          />
        )}
      </PanelBody>
    </Panel>
  );
};

export default LinkControls;
